import React from "react";
import UButton from "ubs-framework/v2/UButton";
import UModal from "ubs-framework/v2/UModal/NewUModal";
import URadio from "ubs-framework/v2/URadio/RadioButton";
import * as Icon from "ubs-icons";
import { copyToClipboard, showToastSuccess } from "ubs-framework/v2/common/function";
import {COLOR} from "ubs-framework/v2/common/constant";

const InterviewFormPopup = (props) => {
    return (
        <UModal
            open={props?.open}
            maxWidth={500}
            className="u_interview-modal"
            header={<h4>{props?.title}</h4>}
            onClose={props?.onClose}
        >
            <div className="u_p-20">
                <p className="u_mb-20 u_font-14">{props?.description}</p>
                {props?.radioOptions.map((opt, index) => (
                    <div key={opt.id} className={`u_row ${index > 0 ? "u_mt-16" : ""}`}>
                        <div className="u_col-12 u_mb-10">
                            <URadio
                                id={opt.id}
                                name="commonRadio"
                                label={opt.label}
                                checked={props?.selectedValue === opt.value}
                                onChange={() => props?.onChange(opt.value)}
                                className="u_mb-5"
                            />
                            <p className="u_ml-28 u_font-14">{opt.text}</p>
                        </div>
                    </div>
                ))}

                {props?.showLinkBox && (
                    <div className="u_interview-share-link u_mt-6 u_p-14 u_border-light u_border-radius-5">
                        <div className="u_flex u_align-center u_content-between">
                            <div className="u_flex u_align-center">
                                <div className="u_p-10 u_bg-white u_border-radius-3">
                                    <Icon.Link size={16}/>
                                </div>
                                <p className="u_ml-10 u_color-title u_font-14">Share form link</p>
                            </div>

                            <p
                                className="u_color-blue u_bg-white u_font-12 u_border-radius-3 u_px-12 u_py-10 u_flex u_align-center u_cp"
                                onClick={() => {
                                    copyToClipboard(props?.linkValue);
                                    showToastSuccess("Link copied to clipboard.");
                                }}
                            >
                                <Icon.Copy size={16} fill={COLOR?.u_blue} className="u_mr-8" />
                                Copy Link
                            </p>
                        </div>
                    </div>
                )}
            </div>

            <div className="u_modal-buttons">
                {/* No toast here: the caller's request can still fail (e.g. slot already booked), its response decides the message */}
                <UButton variant="white" type="Cancel" disabled={props?.loading} onClick={() => props?.onClose()}/>
                <UButton variant="blue" type="Submit" cn="u_ml-10" disabled={props?.loading} loading={props?.loading} onClick={() => props?.onSubmit()}/>
            </div>
        </UModal>
    );
};

export default InterviewFormPopup;
